import { create } from 'apisauce';
import { getAuthToken } from 'utils/cookies';

const token = getAuthToken();

const sendEmailPostmark = async (body) => {
  const api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}/webhook/nodejs/email/send`,
    headers: {
      'content-type': 'application/json',
      'x-authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
    },
  });

  const response = await api.post('', { ...body });
  const { status } = response;
  return status === 200;
};

const sendStudioShare = async (params, projectId) => {
  const api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}/api/wedding/${projectId}/design/share`,
    headers: {
      'Authorization': `Bearer ${token}`,
      'X-Requested-With': 'XMLHttpRequest',
    },
  });

  const response = await api.post('', params);
  return response;
};

const getEmailTemplates = (orgId, leadId) => {
  const api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}/api/organization/${orgId}/templates/emails`,
    headers: {
      'content-type': 'application/json',
      'x-authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
      'X-Requested-With': 'XMLHttpRequest',
    },
  });

  const mergeFieldApi = create({
    baseURL: `${process.env.REACT_APP_AP_URL}/api/organization/${orgId}/leads/${leadId}/email/merge-fields`,
    headers: {
      'content-type': 'application/json',
      'x-authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
      'x-Requested-with': 'XMLHttpRequest',
    },
  });

  return Promise.all([api.get(), leadId ? mergeFieldApi.get() : null]);
};

const sendEmail = async (payload) => {
  const api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}/api/integrations/email/send`,
    headers: {
      'content-type': 'application/json',
      'x-authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
      'x-Requested-with': 'XMLHttpRequest',
    },
  });

  const response = await api.post('', payload);
  return response;
};

// const getEmailThreads = async (orgId, leadId) => {
//   const api = create({
//     baseURL: `${process.env.REACT_APP_AP_URL}/api/organization/${orgId}/leads/${leadId}/threads`,
//     headers: {
//       'content-type': 'application/json',
//       'x-authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
//       'X-Requested-With': 'XMLHttpRequest',
//     },
//   });
//
//   return api.get();
// };

const getCachedEmailThreads = async (orgId, leadId) => {
  const start = Date.now();
  const thread_api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}/api/organization/${orgId}/leads/${leadId}/threads/cache`,
    headers: {
      'content-type': 'application/json',
      'x-authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
      'X-Requested-With': 'XMLHttpRequest',
    },
  });
  return thread_api.get()
    .then(value => ( { value, t: Date.now() - start }));
};

const getEmailThreads = async (orgId, leadId, params = {}) => {
  const start = Date.now();
  const thread_api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}/api/organization/${orgId}/leads/${leadId}/threads-wo-messages`,
    headers: {
      'content-type': 'application/json',
      'x-authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
      'X-Requested-With': 'XMLHttpRequest',
    },
    params,
  });
  return thread_api.get()
    .then(value => ({ value, t: Date.now() - start }));
};

const archiveEmailThread = (orgId, leadId, threadId) => {
  const api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}/api/organization/${orgId}/leads/${leadId}/threads/archive`,
    headers: {
      'content-type': 'application/json',
      'x-authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
      'X-Requested-With': 'XMLHttpRequest',
    },
  });

  return api.post('', { threadId });
};

const unarchiveEmailThread = (orgId, leadId, threadId) => {
  const api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}/api/organization/${orgId}/leads/${leadId}/threads/unarchive`,
    headers: {
      'content-type': 'application/json',
      'x-authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
      'X-Requested-With': 'XMLHttpRequest',
    },
  });

  return api.post('', { threadId });
};

const getThreadMessages = async(orgId, leadId) => {
  const messagesApi = create({
    baseURL: `${process.env.REACT_APP_AP_URL}/api/organization/${orgId}/leads/${leadId}/thread-messages`,
    headers: {
      'content-type': 'application/json',
      'x-authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
      'X-Requested-With': 'XMLHttpRequest',
    },
  });

  return messagesApi.get();
};

const getThreadCleanMessages = async(orgId, leadId, threadId, userGrantId, opEmailAddress) => {
  const messagesApi = create({
    baseURL: `${process.env.REACT_APP_AP_URL}/api/organization/${orgId}/leads/${leadId}/thread-messages`,
    headers: {
      'content-type': 'application/json',
      'x-authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
      'X-Requested-With': 'XMLHttpRequest',
    },
  });

  let opAddress;
  if (!opEmailAddress) {
    opAddress = '';
  } else {
    opAddress = opEmailAddress;
  }

  return messagesApi.post('', { threadId, userGrantId, opEmailAddress: opAddress });
};

// This should be called first before getThreadCleanMessages
const hitThreadCache = async(orgId, leadId, threadId) => {
  const cacheApi = create({
    baseURL: `${process.env.REACT_APP_AP_URL}/api/organization/${orgId}/leads/${leadId}/threads/cache/messages`,
    headers: {
      'content-type': 'application/json',
      'x-authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
      'X-Requested-With': 'XMLHttpRequest',
    },
  });

  return cacheApi.get('', { threadId });
};

const downloadEmailAttachment = async (orgId, leadId, grantId, messageId, attachmentId) => {
  const appUrl = process.env.REACT_APP_AP_URL;
  const api = create({
    baseURL: `${appUrl}/api/organization/${orgId}/leads/${leadId}/threads/cache/messages/attachment`,
    headers: {
      'content-type': 'application/json',
      'x-authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
      'X-Requested-With': 'XMLHttpRequest',
    },
  });

  return api.post('', { grantId, messageId, attachmentId });
};

const getEmailStatus = async (id) => {
  const api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}/api/integrations/email/outbound-status/${id}`,
    headers: {
      'content-type': 'application/json',
      'x-authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
      'X-Requested-With': 'XMLHttpRequest',
    },
  });

  const response = await api.get();
  return response;
};

const deleteEmailStatus = async (id) => {
  const api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}/api/integrations/email/outbound-status/${id}`,
    headers: {
      'content-type': 'application/json',
      'x-authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
      'X-Requested-With': 'XMLHttpRequest',
    },
  });

  const response = await api.delete();
  return response;
};

const getEmailPreview = async (message, user_message, hide_headers) => {
  const api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}/api/views/email-preview`,
    headers: {
      'content-type': 'application/json',
      'x-authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
      'X-Requested-With': 'XMLHttpRequest',
    },
  });

  const response = await api.get('', { message, user_message, hide_headers });
  return response;
};


export {
  sendEmailPostmark,
  sendStudioShare,
  getEmailTemplates,
  sendEmail,
  getCachedEmailThreads,
  getEmailThreads,
  getThreadMessages,
  getThreadCleanMessages,
  downloadEmailAttachment,
  getEmailStatus,
  deleteEmailStatus,
  archiveEmailThread,
  unarchiveEmailThread,
  hitThreadCache,
  getEmailPreview,
};
